<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="rating.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <ngx-view-user-display
            [user]="rating.author"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago
            [currentDate]="rating.createdOn"
          ></ngx-view-time-ago>

          <div class="text-heading">{{ rating.title }}</div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        *ngIf="mode == 'myRating'"
        nbButton
        ghost
        status="danger"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="deleteRating()"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="text-description">{{ rating.description }}</div>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-rating-star [rating]="rating.rating"></ngx-view-rating-star>

      <ngx-button-report-spam
        [rating]="rating"
        (onReport)="report($event)"
      ></ngx-button-report-spam>
    </div>
  </nb-card-footer>
</nb-card>
